import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBoxPlot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 2.75C19.9142 2.75 20.25 3.08579 20.25 3.5V5.25H20.5C21.7426 5.25 22.75 6.25736 22.75 7.5V11.5C22.75 12.7426 21.7426 13.75 20.5 13.75H20.25V15.5C20.25 15.9142 19.9142 16.25 19.5 16.25C19.0858 16.25 18.75 15.9142 18.75 15.5V13.75H18.5C17.2574 13.75 16.25 12.7426 16.25 11.5V7.5C16.25 6.25736 17.2574 5.25 18.5 5.25H18.75V3.5C18.75 3.08579 19.0858 2.75 19.5 2.75ZM20.5 12.25C20.9142 12.25 21.25 11.9142 21.25 11.5V7.5C21.25 7.08579 20.9142 6.75 20.5 6.75H18.5C18.0858 6.75 17.75 7.08579 17.75 7.5V11.5C17.75 11.9142 18.0858 12.25 18.5 12.25H20.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.25 10.5C1.25 9.25736 2.25736 8.25 3.5 8.25H3.75V6.5C3.75 6.08579 4.08579 5.75 4.5 5.75C4.91421 5.75 5.25 6.08579 5.25 6.5V8.25H5.5C6.74264 8.25 7.75 9.25736 7.75 10.5V14.5C7.75 15.7426 6.74264 16.75 5.5 16.75H5.25V18.5C5.25 18.9142 4.91421 19.25 4.5 19.25C4.08579 19.25 3.75 18.9142 3.75 18.5V16.75H3.5C2.25736 16.75 1.25 15.7426 1.25 14.5V10.5ZM5.5 15.25C5.91421 15.25 6.25 14.9142 6.25 14.5V10.5C6.25 10.0858 5.91421 9.75 5.5 9.75H3.5C3.08579 9.75 2.75 10.0858 2.75 10.5V14.5C2.75 14.9142 3.08579 15.25 3.5 15.25H5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.75 11.5C8.75 10.2574 9.75736 9.25 11 9.25H11.25V7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V9.25H13C14.2426 9.25 15.25 10.2574 15.25 11.5V17.5C15.25 18.7426 14.2426 19.75 13 19.75H12.75V21.5C12.75 21.9142 12.4142 22.25 12 22.25C11.5858 22.25 11.25 21.9142 11.25 21.5V19.75H11C9.75736 19.75 8.75 18.7426 8.75 17.5V11.5ZM13 18.25H11C10.5858 18.25 10.25 17.9142 10.25 17.5V11.5C10.25 11.0858 10.5858 10.75 11 10.75H13C13.4142 10.75 13.75 11.0858 13.75 11.5V17.5C13.75 17.9142 13.4142 18.25 13 18.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconBoxPlot as ReactComponent };
